import { render, staticRenderFns } from "./RoleSetRight.vue?vue&type=template&id=66e9c438&scoped=true"
import script from "./RoleSetRight.vue?vue&type=script&lang=js"
export * from "./RoleSetRight.vue?vue&type=script&lang=js"
import style0 from "./RoleSetRight.vue?vue&type=style&index=0&id=66e9c438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e9c438",
  null
  
)

export default component.exports